import BeholdWidget from "@behold/react"

export function History() {
    return (
        <div className='card' id='gallery'>
            <h2>Galeria</h2>
            <BeholdWidget feedId="x8EvwsF2OCEkyWi1H5sg"></BeholdWidget>
        </div>
    )
}